import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import HttpServices from '../utils/Http.services'
import { checkTranslation, translate } from '../utils/useful'
import { actionsData } from '../variables/actionsData'
import ButtonAnimated from './buttons/ButtonAnimated'
import SwitchInput from './inputs/SwitchInput'
import * as actions from '../stores/actionsList';
import FormViewer from './FormViewer'
import Modal from './Modal'
import StagesManager from './StagesManager'

class AddWorkflowFromApplet extends Component {
    state = {
        actionList: [],
        data: {},
        actions: [],
        headers: [
            // { key: 'type', type: 'SelectInput', col: '12', information: {label: 'Action type', placeholder: 'Choose...',  type: "local", items: [{ title: 'view', value: 'View' }, { title: 'edit', value: 'edit' }, { title: 'view history', value: 'viewHistory' }, { title: 'remove', value: 'remove' }, { title: 'share', value: 'share' }, { title: 'change stage', value: 'changeStage' }, { title: 'next stage', value: 'nextStage' }, { title: 'send to', value: 'sendTo' }, { title: 'send as mail', value: 'sendAsMail' }, { title: 'request approval', value: 'requestApproval' }, { title: 'download as pdf', value: 'downloadAsPdf' }, { title: 'share', value: 'share' }, { title: 'open window', value: 'openWindow' }], required: true } },
            { key: 'name', type: 'TextInput', col: '12', information: { label: 'Action Name', placeholder: 'Name to be used in the list', required: true } },

            // { key: 'type', type: 'SelectInput', col: '12', information: { label: 'Action type', placeholder: 'Choose...', type: "local", items: [{ title: 'Run automation', value: 'runAutomation' }, { title: 'Open window', value: 'openWindow' }, { title: 'View history', value: 'viewHistory' }, { title: 'Change stage', value: 'changeStage' }, { title: 'Next stage', value: 'nextStage' }, { title: 'Change stage to ...', value: 'changeStageTo' }, { title: 'Send to', value: 'sendTo' }, { title: 'Send as ...', value: 'sendAs' }, { title: 'Request approval', value: 'requestApproval' }, { title: 'Download as pdf', value: 'downloadAsPdf' }, { title: 'Share', value: 'share' },], required: true } },







            // {
            //     key: 'page', type: 'SelectInput', col: '12', information: { label: '{{lang}}pages', type: 'api', address: 'getFrames', filter: { type: 'page' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}pages', required: false }, showMain: false,
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'page',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'openWindow' } } }, },
            //             effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
            //         }],
            //         else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
            //         init: true,
            //         // show:true,

            //     }]

            // },
            // {
            //     key: 'recipients', type: 'TextInput', col: '12', information: { label: '{{lang}}Recipients', placeholder: '{{lang}}Recipients', required: false }, showMain: false,
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'recipients',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'sendAsMail' } } }, },
            //             effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
            //         }],
            //         else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
            //         init: true,
            //         // show:true,

            //     }]

            // },
            // {
            //     key: 'subject', type: 'TextInput', col: '12', information: { label: '{{lang}}Subject', placeholder: '{{lang}}Subject', required: false }, showMain: false,
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'subject',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'sendAsMail' } } }, },
            //             effect: { show: true }
            //         }],
            //         else: { show: false },
            //         init: true,
            //         // show:true,

            //     }]

            // },
            // {
            //     key: 'body', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Body', placeholder: '{{lang}}Body', required: false }, showMain: false,
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'body',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'sendAsMail' } } }, },
            //             effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
            //         }],
            //         else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
            //         init: true,
            //         // show:true,

            //     }]

            // },
            // {
            //     key: 'attachments', type: 'FileInput', col: '12', information: { label: '{{lang}}Attachments', required: false }, showMain: false,
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'attachments',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'sendAsMail' } } }, },
            //             effect: { show: true }
            //         }],
            //         else: { show: false },
            //         init: true,
            //         // show:true,

            //     }]
            // },


            { key: 'hasCondition', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available just in specific conditions', hint: 'If you want the action to always be available, do not use this option.', default: false, required: false } },

            {
                key: 'condition', type: 'FilterEditorInput', col: '12', information: { label: 'Availablity condition', placeholder: 'Choose...', type: "local", items: [], required: false },
                dependencies: [{
                    refKey: 'hasCondition', targetKey: 'condition',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.hasCondition' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,
                    // show:true,

                }]
            },

            // { key: 'reusable', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Can be used in other frames', hint: 'If you turn on the option, this action can be used by other frames of this applet. Permissions will be considered for each frame individually.', default: false, required: false } },


        ]
    }
    // componentDidMount = () => {
    //     this.init()
    // }

    open = () => {
        this.init()
        this.modal.showModal()
    }

    init = () => {
        // TO DO: get applet actions (Fetch the actions which are available for being used in other frames)
        // console.log('this.prrr', this.props)
        let body = { applet: this.props.variables?.appletId }
        HttpServices.request('getReusedAutomations', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }

            this.setState({ actions: fetchResult.info, currentStage: 0 })
        })
    }


    changeValue = (key, value, extra) => {
        let actionList = this.state.actionList
        if (value) {
            actionList.push(key)
        }
        else {
            let aIndex = actionList.indexOf(key)
            actionList.splice(aIndex, 1)
        }
        this.setState({ actionList })
    }


    submitWorkflow = () => {
        if (this.form.getForm()) {
            this.setState({ isLoadingData: true })
            let variables = this.props.variables
            let body = { applet: variables.appletId, frame: this.props.frame?._id }
            let page = this.props.page


            body.frame = page?._id
            body.actions = this.form.getForm()

            // TO DO: may need to change the API
            HttpServices.request('postFlow', body, (fetchResult, fetchError) => {
                this.setState({ isLoadingData: false })
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataPostedSuccessfully' })
                // TO DO: update the main list
            })
        }
    }


    selectRow = (row) => {
        this.stageManager.nextStage()
        this.setState({ currentRow: row, currentStage: 1 })
    }

    goToFirstStage = () => {
        this.setState({ currentStage: 0 })
        this.stageManager.changeStage(0)
    }





    render() {
        return (

            <Modal width={this.props.width} maxWidth={400} zIndex={40} ref={el => this.modal = el} >
                <div className={'h-100 scroll-no-scrollbar pb-5 br-8 '} style={{ backgroundColor: '#fff', }}>
                    <div className='w-100'>
                        <div className='px-3 py-1 w-100 flexcb mb-3' style={{ borderBottom: '1px solid #eee' }}>
                            <div className='flexc mrd-2'>
                                {this.state.currentStage == 1 && (
                                    <button className='flexcc rotate-180' onClick={() => this.goToFirstStage()}>
                                        <img src={'/assets/icons/tower/arrow-right.svg'} width={20} />
                                    </button>
                                )}
                                <p className='text-semibold py-2 px-1'>{translate("Add workflow")}</p>
                            </div>
                            {this.state.currentStage == 1 && (
                                <div className="flexc mrd-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        icon='/assets/icons/plus-white.svg'
                                        onClick={() => { this.submitWorkflow() }}
                                        isLoading={this.state.isLoadingData}
                                        title={translate('Create')}
                                        textColor={'#fff'}
                                        bg={this.props.background ?? ' linear-gradient(90deg, #5856D6, #7D7AFF)'}
                                        width={'100%'}
                                    />


                                </div>
                            )}
                        </div>


                        <StagesManager ref={el => this.stageManager = el} fast={true}  >

                            <div stage={0} stageName={"init"}>
                                <div className='px-3'>

                                    {this.state.actions?.length == 0 && (
                                        <div className='px-1 pt-3 text-center flexc flex-column'>
                                            <p className='text-normal text-semibold'>{translate("Found nothing")}</p>
                                            <p className='text-small color-gray-2 mt-1' style={{ maxWidth: 250 }}>{translate("Applet actions can be manged from applet settings, actions sections.")}</p>
                                        </div>
                                    )}

                                    {this.state.actions?.length > 0 && (

                                        <div>

                                            <div className='px-1 mb-2'>
                                                <p className='text-normal text-semibold'>{translate("Applet workflows")}</p>
                                                <p className='text-smaller mt-1'>{translate("Select one of the workflows to continue")}</p>
                                            </div>

                                            {this.state.actions?.map((prop, index) => {
                                                return (
                                                    <button onClick={() => this.selectRow(prop)} key={index} className='pt-2 pb-2 w-100' style={{ borderBottom: '1px solid #f2f2f2' }}>
                                                        <div className='mld-2 flexcb w-100'>
                                                            <div className='flexc'>
                                                                <p className='text-small text-semibold'>{prop?.type}</p>


                                                            </div>

                                                            <div className='flexc'>

                                                                <div className='br-4 mld-2 px-2 py-1 text-smallest text-semibold color-gray-2' style={{ background: "#eee" }}>{translate(prop?.mode ?? 'basic')}</div>
                                                                <img src={'/assets/icons/tower/arrow-right.svg'} className='mx-2' width={20} />

                                                            </div>

                                                        </div>
                                                    </button>
                                                )
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div stage={1} stageName={"info"}>
                                <div className='px-3'>
                                    <p>TO DO: Show stage map</p>
                                    <p>TO DO: Show stages list</p>
                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </div>
            </Modal>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(AddWorkflowFromApplet);